import lodash from 'lodash';

export const getState = (state, param = null, defaultValue = null) => lodash.get(state, 'barcode.scanningHistory' + (param ? '.' + param : ''), defaultValue);
